<template>
    <form-row title="Who Pays Title?">
        <input-checkbox
            name="buyer_pays_title"
            label="Buyer"
            :value="deal.buyer_pays_title"
            :read_only="read_only"
        />

        <input-checkbox
            name="seller_pays_title"
            label="Seller"
            :value="deal.seller_pays_title"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
